module.exports = __webpack_public_path__ + "img/havebeenused@2x.d1528533.png";